import CodeView from 'src/components/CodeView';
import directionRow from 'src/examples/CSS/Flexbox/directionRow';
import directionColumn from 'src/examples/CSS/Flexbox/directionColumn';
import justifyContent from 'src/examples/CSS/Flexbox/justifyContent';
import alignItems from 'src/examples/CSS/Flexbox/alignItems';
import alignSelf from 'src/examples/CSS/Flexbox/alignSelf';
import wrapFlexbox from 'src/examples/CSS/Flexbox/wrap';
import wrapFlexbox2 from 'src/examples/CSS/Flexbox/wrap2';
import alignContent from 'src/examples/CSS/Flexbox/alignContent';
import fillFlexbox from 'src/examples/CSS/Flexbox/fill';
import growFlexbox from 'src/examples/CSS/Flexbox/grow';
import shrinkFlexbox from 'src/examples/CSS/Flexbox/shrink';
import autoMargin from 'src/examples/CSS/Flexbox/autoMargin';
import withAlignItem from 'src/examples/CSS/Flexbox/withAlignItem';
import orderFlexbox from 'src/examples/CSS/Flexbox/order';
import * as React from 'react';
export default {
  CodeView,
  directionRow,
  directionColumn,
  justifyContent,
  alignItems,
  alignSelf,
  wrapFlexbox,
  wrapFlexbox2,
  alignContent,
  fillFlexbox,
  growFlexbox,
  shrinkFlexbox,
  autoMargin,
  withAlignItem,
  orderFlexbox,
  React
};